import { keyframes } from 'styled-components';

/**
 * Rotate element 360deg
 * for example in animation loading
 */
const Rotate360 = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

export default Rotate360;
